var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "last-wins" }, [
    _c("div", { staticClass: "last-wins__container" }, [
      _c("div", { staticClass: "last-wins__header" }, [
        _vm._m(0),
        _c("div", { staticClass: "last-wins__actions" }, [
          _c(
            "div",
            { staticClass: "filter-switch" },
            _vm._l(_vm.filterButtons, function (item, index) {
              return _c(
                "button",
                {
                  key: index,
                  staticClass: "filter-switch__btn",
                  class:
                    _vm.activeIndex === index
                      ? "filter-switch__btn--active"
                      : "filter-switch__btn--inactive",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.toggleFilter(index)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "filter-switch__btn-inner",
                      class: {
                        "filter-switch__btn-inner--active":
                          _vm.activeIndex === index,
                      },
                    },
                    [
                      !_vm.isLg
                        ? _c(
                            "span",
                            {
                              staticClass: "filter-switch__text",
                              class:
                                _vm.activeIndex === index
                                  ? "filter-switch__text--active"
                                  : "filter-switch__text--inactive",
                            },
                            [_vm._v(" " + _vm._s(item.label) + " ")]
                          )
                        : _vm._e(),
                      _c("i", {
                        staticClass: "icon filter-switch__icon",
                        class: [
                          item.icon,
                          _vm.activeIndex === index
                            ? "filter-switch__icon--active"
                            : "filter-switch__icon--inactive",
                        ],
                      }),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
          _vm.isAuthenticated
            ? _c(
                "a",
                { staticClass: "history-btn", on: { click: _vm.openHistory } },
                [_vm._m(1)]
              )
            : _vm._e(),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "cards-container" },
        _vm._l(_vm.displayedGames, function (game) {
          return _c("last-wins-card", { key: game.id, attrs: { game: game } })
        }),
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "last-wins__title-box" }, [
      _c("i", { staticClass: "icon icon_Award last-wins__title-icon" }),
      _c("span", { staticClass: "last-wins__title-text" }, [
        _vm._v("最近获胜"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "history-btn__inner" }, [
      _c("i", { staticClass: "icon icon_history history-btn__icon" }),
      _c("span", { staticClass: "history-btn__text" }, [_vm._v("历史")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }